import {requirePermission} from '@/modules/auth/permissions'
import {useGetSolutionDrug} from '@/modules/drug-catalog/solutions/api/use-get-solution-drug'
import {SolutionForm} from '@/modules/drug-catalog/solutions/components'
import {EditResourceTitle} from '@/shared/components/ui/edit-resource-title'
import {NewSolutionPageSearchSchema} from '@/modules/drug-catalog/solutions/schemas'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/configuration/drug-catalog/solutions/new')({
  beforeLoad: requirePermission('catalogue.manage'),
  component: NewSolutionPage,
  validateSearch: NewSolutionPageSearchSchema,
})

function NewSolutionPage() {
  const {t} = useTranslate('solutions')
  const {solutionId} = Route.useSearch()
  const [solution] = useGetSolutionDrug(solutionId)

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={
          solutionId ? (
            <EditResourceTitle label={t('edit_solution_title')} name={solution?.name} />
          ) : (
            t('new_solution_title')
          )
        }
        description={t('new_solution_description')}
      />

      <SolutionForm solutionId={solutionId} />
    </NewResourceFormContainer>
  )
}
